import React from 'react';

const CustomCss = ({ slice }) => (
  <style dangerouslySetInnerHTML={{ __html: slice.primary.code }} />
);

export default CustomCss;
